import { Schema } from 'normalizr';

export const publisherSchema = new Schema('publishers', { idAttribute: 'id' });

export const userSchema = new Schema('user', { idAttribute: 'id' });
